import { Component, OnInit } from '@angular/core';

@Component({
  templateUrl: './music.component.html',
  styleUrls: ['./music.component.scss']
})
export class MusicComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
